import moment from 'moment';

import iosInApp from './ios-in-app/ios-in-app';
import iosSafariOutdated from './ios-safari-outdated/ios-safari-outdated';
import legacyMessages from './legacy-messages/legacy-messages';

import template from './unsupported-browser.html';

const statuses = {
  iosSafariOutdated: 'ios-safari-outdated',
  iosInApp: 'ios-in-app',
  unsupported: 'unsupported',
  outdated: 'outdated',
};

const checkIfDaysHavePassed = (date, daysCount = 7) =>
  moment().diff(date, 'days') >= daysCount;

export default angular
  .module('doxy.common.components.unsupportedBrowser', [
    iosInApp,
    iosSafariOutdated,
    legacyMessages,
  ])
  .component('unsupportedBrowser', {
    template,
    controller: function (Browser, $window, $scope, notificationFactory) {
      $scope.statuses = statuses;
      this.status = null;

      this.getStatus = () => {
        switch (true) {
          case Browser.isLegacyMobileSafari():
            return statuses.iosSafariOutdated;
          case Browser.isIosInAppBrowser():
            return statuses.iosInApp;
          case !Browser.isSupported():
            return statuses.unsupported;
          case !Browser.isUpToDate():
            return statuses.outdated;
          default:
            return null;
        }
      };

      this.$onInit = () => {
        const localStorageKeyForLastShowDate =
          'unsupported-browser-last-show-date';
        const lastShowDate = $window.localStorage.getItem(
          localStorageKeyForLastShowDate
        );

        this.status = this.getStatus();

        if (this.status === statuses.outdated) {
          if (
            !lastShowDate ||
            checkIfDaysHavePassed(moment.unix(lastShowDate))
          ) {
            $window.localStorage.setItem(
              localStorageKeyForLastShowDate,
              moment().unix()
            );
            notificationFactory.showCommon('warning', 'update-browser');
          }
          this.status = null;
        }
      };

      this.hide = () => {
        this.status = null;
      };
    },
  }).name;
